import { Theme } from "@mui/material/styles";
import { primary } from "app/themes/colors";

export const getCheckboxComponents = (sunoTheme: Theme) => ({
  MuiCheckbox: {
    styleOverrides: {
      root: {
        "& .MuiSvgIcon-root": {
          fontSize: 24,
        },
        "&:not(.Mui-disabled) .MuiSvgIcon-root": {
          color: primary[500],
        },
      },
    },
  },
});
